<template>
  <div id="js-zoom">
  </div>
</template>

<script>
import L from 'leaflet'
require('leaflet-iiif')
require('leaflet-easybutton')

export default {
  name: 'ViewerDeepZoom',
  props: ['imageURL'],

  data () {
    return {
      el: 'js-zoom',
      map: null
    }
  },

  mounted () {
    this.createMap()
  },

  methods: {
    createMap () {
      this.map = L.map('js-zoom', {
        center: [0, 0],
        crs: L.CRS.Simple,
        zoom: 0
      })

      this.map.scrollWheelZoom.disable()
      L.tileLayer.iiif(this.imageURL + '/info.json').addTo(this.map)
      L.easyButton('ion-md-information-circle ion-5x deepzoom-metadata', () => {
        this.$emit('toggle-metadata')
      }).addTo(this.map)
    }
  },

  watch: {
    imageURL (newURL) {
      this.map.remove()
      this.map = null
      this.createMap()
    }
  }
}

</script>

<style scoped>
#js-zoom {
  background-color: #000;
  flex: 1;
  height: 100%;
  width: 100%;
}
</style>

<style>
.easy-button-button {
  background-color: #fff;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/viewer/DeepZoom.vue?08135b16